export default __webpack_public_path__ + "static/media/search.90a8e0d6.svg";